import React from 'react';
import AnswerItem from '../answerItem';
import './answers.css';

const Answers = props => {
  return (
    <div className="answers">
      <h3 className="h3">Варианты ответов</h3>
      <div className="answers__inner">
        {props.questions.answers.map((value, index) => (
          <div key={index} className="answers__item">
            <AnswerItem
              index={index}
              answer={value}
              testType={props.testType}
              changeTextAnswer={props.changeTextAnswer}
              changeTextGroup={props.changeTextGroup}
              changeCommentAnswer={props.changeCommentAnswer}
              changeCorrectAnswer={props.changeCorrectAnswer}
              createAnswer={props.createAnswer}
              removeAnswer={props.removeAnswer}
              lengthAnswers={props.questions.answers.length}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Answers;
